module.exports = __webpack_public_path__ + "static/mo03-8d107a839fd22cf379f5fb491148d8a0.png";